import { render, staticRenderFns } from "./certificateForm.vue?vue&type=template&id=44141ff1&scoped=true"
import script from "./certificateForm.vue?vue&type=script&lang=js"
export * from "./certificateForm.vue?vue&type=script&lang=js"
import style0 from "./certificateForm.vue?vue&type=style&index=0&id=44141ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44141ff1",
  null
  
)

export default component.exports